// SmartSearchNavbar.jsx (ULTRA COMPACT)
// Replace your existing SmartSearchNavbar.jsx with this file.
// Reference: original inspected file. :contentReference[oaicite:2]{index=2}

import React, { useEffect, useState, useRef } from "react";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import { customEncode, authFetch } from "../DecryptData"; // adjust path if needed
import { FetchFromServer } from "../api/ServerApi";

// compact language toggle
function SmallLangToggle() {
  const changeLanguage = (lang) => {
    const attempt = () => {
      const select = document.querySelector("select.goog-te-combo");
      if (!select) setTimeout(attempt, 300);
      else {
        select.value = lang;
        select.dispatchEvent(new Event("change"));
      }
    };
    attempt();
  };

  const btn = {
    padding: "3px 6px",
    fontSize: 11,
    borderRadius: 4,
    border: "none",
    background: "#fff",
    cursor: "pointer",
    height: 26,
  };

  return (
    <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
      <button onClick={() => changeLanguage("en")} style={btn} title="English">EN</button>
      <button onClick={() => changeLanguage("mr")} style={btn} title="मराठी">MR</button>
    </div>
  );
}

function SmartSearchNavbar({
  onSearchResults = () => { },
  panels = [],
  setPanels = () => { },
  selectedPanel,
  setSelectedPanel,
  selectedCorporationId,
  partySymbolImg,   // ✅ ADD THIS
  setSelectedCorporationId = () => { },
}) {
  const [selectedCandidateId, setSelectedCandidateId] = useState(null);
  const [userName, setUserName] = useState("");
  const [userSurname, setUserSurname] = useState("");
  const [userId, setUserId] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");

  const [searchText, setSearchText] = useState("");
  const [liveSearch, setLiveSearch] = useState(false);
  const [rowsCount, setRowsCount] = useState(0);
const developedFor = selectedPanel?.CandidateName || "";


  const [stats, setStats] = useState({
    TotalVoterCount: 0,
    TotalVoterSurveyCount: 0,
    TotalVBooth: 0,
    TotalPermission: 0,
  });
  const [showMsgModal, setShowMsgModal] = useState(false);
  const [msgModalText, setMsgModalText] = useState("");

  const [isSearching, setIsSearching] = useState(false);
  const searchTimeout = useRef(null);

  useEffect(() => {
    const name = localStorage.getItem("Name");
    const surname = localStorage.getItem("Surname");
    const id = localStorage.getItem("UserId");
    const mobile = localStorage.getItem("MobileNumber");

    if (name) setUserName(name);
    if (surname) setUserSurname(surname);
    if (id) setUserId(id);
    if (mobile) setMobileNumber(mobile);

    if (mobile) fetchPanelsForNavbar(mobile);
  }, []);

  const fetchPanelsForNavbar = async (mobile) => {
    try {
      const res = await authFetch(
        "http://anuplights.in:8083/apisecure/GetListOfCorpPanelsForUserbyMobileNumber",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            data: customEncode(JSON.stringify({ MobileNumber: mobile })),
          }),
        }
      );

      const data = await res.json();
      const mappings = data[0]?.CandidateMappings || [];

      const formattedPanels = mappings.map((item) => ({
        PanelNumber: item.PanelNumber,
        CorporationId: item.CorporationId,
        CorporationName: item.CorporationName,
        CorpCandidateMappingId: item.CorpCandidateMappingId,
        CandidateId: item.CandidateId,

        CandidateName: item.CandidateName, // ✅ THIS IS KEY

        PartySymbolImageId: item.PartySymbolImageId, // ✅ KEY FIX

        TotalVoterCount: item.TotalVoterCount || 0,
        TotalVoterSurveyCount: item.TotalVoterSurveyCount || 0,
        TotalVBooth: item.TotalVBooth || 0,
        Fore_RedCPer: item.Fore_RedCPer,
        Fore_GreenPer: item.Fore_GreenPer,
        Fore_BluePer: item.Fore_BluePer,
        Back_RedCPer: item.Back_RedCPer,
        Back_GreenPer: item.Back_GreenPer,
        Back_BluePer: item.Back_BluePer,
      }));


      setPanels(formattedPanels);

      if (formattedPanels.length > 0) {
        const first = formattedPanels[0];
        setSelectedPanel(first);
        setSelectedCorporationId(first?.CorporationId);
        setSelectedCandidateId(first?.CandidateId);
      }

      localStorage.setItem("Name", data[0]?.Name ?? "");
      localStorage.setItem("Surname", data[0]?.Surname ?? "");
      localStorage.setItem("UserId", data[0]?.UserId ?? "");
      localStorage.setItem("MobileNumber", data[0]?.MobileNumber ?? "");

      setStats((prev) => ({ ...prev, TotalPermission: Number(data[0]?.Balance ?? 0) }));
    } catch (err) {
      console.log("Panel fetch error:", err);
    }
  };

  useEffect(() => {
    if (selectedPanel) {
      setStats((prev) => ({
        ...prev,
        TotalVoterCount: selectedPanel.TotalVoterCount,
        TotalVoterSurveyCount: selectedPanel.TotalVoterSurveyCount,
        TotalVBooth: selectedPanel.TotalVBooth,
      }));

      if (searchText.trim()) handleSearch(searchText, selectedPanel, selectedCandidateId);
    }
  }, [selectedPanel]);

  useEffect(() => {
    if (selectedPanel?.PanelNumber === 0) {
      setLiveSearch(false);
    }
  }, [selectedPanel]);

  const handleSearch = async (text = searchText, panel = selectedPanel, candidateIdArg = selectedCandidateId) => {
    if (!panel || !text.trim()) {
      // clear counts if no search
      setRowsCount(0);
      onSearchResults([]);
      return;
    }

    const resolvedCandidateId = candidateIdArg ?? selectedCandidateId ?? panel?.CandidateId ?? null;

    const payload = {
      UserId: Number(userId),
      PanelNumber: Number(panel.PanelNumber),
      CorporationId: Number(panel.CorporationId),
      message: text.trim(),
      CandidateId: resolvedCandidateId !== null ? Number(resolvedCandidateId) : null,
    };

    setIsSearching(true);
    try {
      const res = await authFetch(
        "http://anuplights.in:8083/apisecure/SearchMixCorpData",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ data: customEncode(JSON.stringify(payload)) }),
        }
      );

      if (!res.ok) {
        setStats((prev) => ({ ...prev, TotalPermission: 0 }));
        onSearchResults([]);
        setRowsCount(0);
        return;
      }

      const result = await res.json();

      if (Array.isArray(result) && result.length === 1 && typeof result[0].message === "string") {
        setMsgModalText(result[0].message);
        setShowMsgModal(true);
        onSearchResults([]);
        setRowsCount(0);
        return;
      }

      if (!Array.isArray(result)) {
        setStats((prev) => ({ ...prev, TotalPermission: 0 }));
        onSearchResults([]);
        setRowsCount(0);
        return;
      }

      const formatted = result.map((item) => ({
        PanelNumber: item.PanelNumber,
        VoterNumber: item.VoterNumber,
        Assembly: `${item.constno || ""}/${item.yadibhag || ""}/${item.vno || ""}`,
        esurname: item.esurname || "",
        name_english: item.name_english || "",
        relative_english: item.relative_english || "",
        age: item.age ?? "",
        sex: item.sex ?? "",
        CardNo: item.CardNo || item.cardno || "",
        MobileNumber: item.MobileNumber || item.mobile || "",
        CandidateFullName: item.CandidateFullName || "",
        CandidateMobile1: item.MobileNumber || item.CandidateMobile1 || "",
        address: item.Address || item.address || "",
        cardno: item.CardNo || item.cardno || "",
        constno: item.constno || "",
        CandidateId: item.CandidateId ?? null,
      }));

      const serverBalance =
        (result[0] && (result[0].Balance ?? null)) ??
        (result[result.length - 1] && (result[result.length - 1].Balance ?? null)) ??
        null;

      if (panel?.PanelNumber === 0) {
        // ✅ ONLY Panel 0 can change permission count
        if (serverBalance !== null && serverBalance !== undefined) {
          setStats((prev) => ({
            ...prev,
            TotalPermission: Number(serverBalance),
          }));
        } else {
          setStats((prev) => ({
            ...prev,
            TotalPermission: Math.max((prev.TotalPermission || 0) - 1, 0),
          }));
        }
      }
      // ❌ Other panels → DO NOTHING (permission remains unchanged)



      setRowsCount(formatted.length);
      onSearchResults(formatted);
    } catch (error) {
      console.log("Search error:", error);
      setRowsCount(0);
    } finally {
      setIsSearching(false);
    }
  };

  const handleSearchInputChange = (e) => {
    const value = e.target.value;
    setSearchText(value);

    if (liveSearch) {
      if (searchTimeout.current) clearTimeout(searchTimeout.current);

      searchTimeout.current = setTimeout(() => {
        if (value.trim()) handleSearch(value);
        else {
          onSearchResults([]);
          setRowsCount(0);
        }
      }, 350);
    }
  };

 const handleClearSearch = () => {
  setSearchText("");
  setRowsCount(0);
  onSearchResults([]);
};


  const themeColor = selectedPanel
    ? `rgb(${selectedPanel.Fore_RedCPer}, ${selectedPanel.Fore_GreenPer}, ${selectedPanel.Fore_BluePer})`
    : "#007bff";

  return (
    <>
      {/* NAVBAR - ULTRA COMPACT */}
      <Navbar
        expand="lg"
        className="px-2"
        style={{
          backgroundColor: themeColor,
          color: "white",
          paddingTop: "4px",
          paddingBottom: "4px",
          minHeight: "36px",
          zIndex: 2000,
        }}
      >
        <Container fluid>
          <Navbar.Brand
            style={{
              color: "white",
              fontWeight: 700,
              display: "flex",
              gap: 12,
              alignItems: "center",
              fontSize: 13,
            }}
          >
            {/* ✅ PARTY SYMBOL IMAGE */}
            {partySymbolImg && (
              <img
                src={partySymbolImg}
                alt="Party Symbol"
                style={{
                  width: 28,
                  height: 28,
                  objectFit: "contain",
                  background: "white",
                  borderRadius: 4,
                  padding: 2,
                }}
              />
            )}

            <span style={{ whiteSpace: "nowrap" }}>
              User: {userName} {userSurname} (ID: {userId})
            </span>

          <span style={{ whiteSpace: "nowrap", fontWeight: 500 }}>
  Developed For: {selectedPanel?.CandidateName || ""}
</span>

          </Navbar.Brand>


          <Navbar.Toggle />
          <Navbar.Collapse>
            <Nav className="me-auto" style={{ marginLeft: 6 }}>
              <NavDropdown
                title={
                  <span style={{ color: "white", fontSize: 12 }}>
                    {selectedPanel
                      ? `Panel ${selectedPanel.PanelNumber} (${selectedPanel.CorporationName} / ${selectedPanel.CorporationId})`
                      : "Select Panel"}
                  </span>
                }
                menuVariant="dark"
                style={{ color: "white" }}
              >
                {panels.map((p) => (
                  <NavDropdown.Item
                    key={`${p.PanelNumber}-${p.CorporationId}`}
                    onClick={() => {
                      setSelectedPanel(p);
                      setSelectedCorporationId(p.CorporationId);
                      setSelectedCandidateId(p.CandidateId);
                    }}
                    active={
                      selectedPanel?.PanelNumber === p.PanelNumber &&
                      selectedPanel?.CorporationId === p.CorporationId
                    }
                    style={{ color: "white", backgroundColor: "#333", fontSize: 12 }}
                  >
                    Panel {p.PanelNumber} ({p.CorporationName} / {p.CorporationId})
                  </NavDropdown.Item>
                ))}
              </NavDropdown>
            </Nav>

            {/* SEARCH BAR (compact) */}
            <Form className="d-flex align-items-center" onSubmit={(e) => e.preventDefault()}>
              <div style={{ position: "relative" }}>
               <div style={{ position: "relative" }}>
  <Form.Control
    className="me-2"
    type="text"
    placeholder="Search..."
    value={searchText}
    onChange={handleSearchInputChange}
    onKeyDown={(e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        handleSearch();
      }
    }}
    style={{
      width: 220,
      padding: "4px 26px 4px 6px",
      fontSize: 12,
      height: 30,
    }}
  />

  {/* ❌ CLEAR BUTTON */}
  {searchText && (
    <span
      onClick={handleClearSearch}
      title="Clear"
      style={{
        position: "absolute",
        right: 14,
        top: "50%",
        transform: "translateY(-50%)",
        cursor: "pointer",
        fontWeight: "bold",
        fontSize: 14,
        color: "#555",
        userSelect: "none",
      }}
    >
      ✕
    </span>
  )}
</div>



                {searchText.length > 0 && (
                  <span
                    onClick={handleClearSearch}
                    style={{
                      position: "absolute",
                      right: 6,
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      fontWeight: "bold",
                      fontSize: 12,
                    }}
                  >
                    ✕
                  </span>
                )}
              </div>

              <Button onClick={() => handleSearch()} className="ms-2" disabled={isSearching} style={{ padding: "4px 8px", fontSize: 12, height: 30 }}>
                {isSearching ? "Searching..." : "Search"}
              </Button>

              <Form.Check
                type="switch"
                id="live-search-switch"
                label="Live"
                checked={liveSearch}
                disabled={selectedPanel?.PanelNumber === 0}
                onChange={(e) => setLiveSearch(e.target.checked)}
                className="ms-2"
                style={{ color: "white", opacity: selectedPanel?.PanelNumber === 0 ? 0.5 : 1, fontSize: 12 }}
              />

              <div className="ms-2" style={{ display: "flex", alignItems: "center" }}>
                <SmallLangToggle />
              </div>
            </Form>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Loading modal (small) */}
      <Modal show={isSearching} centered backdrop="static" keyboard={false}>
        <Modal.Body style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 12px" }}>
          <Spinner animation="border" role="status" size="sm" />
          <div>
            <div style={{ fontWeight: 700, fontSize: 13 }}>Please wait</div>
            <div style={{ fontSize: 12, color: "#555" }}>Searching data for your requirement...</div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Server message modal */}
      <Modal show={showMsgModal} onHide={() => setShowMsgModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 13 }}>Message</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ fontSize: 13 }}>
          <div>{msgModalText}</div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowMsgModal(false)} style={{ fontSize: 12 }}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

     {/* ULTRA-COMPACT STATS BAR */}
<div
  style={{
    position: "sticky",
    top: 36,
    width: "100%",
    backgroundColor: themeColor,
    color: "white",
    display: "flex",
    padding: "3px 8px",
    fontSize: 12,
    alignItems: "center",
    zIndex: 1999,
  }}
>
  <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
    {/* ✅ ALWAYS SHOW */}
    <div>Total Voters : {stats.TotalVoterCount}</div>

    {/* 🔓 ONLY PANEL 0 */}
    {selectedPanel?.PanelNumber === 0 && (
      <>
        <div>Survey : {stats.TotalVoterSurveyCount}</div>
        <div>Booth : {stats.TotalVBooth}</div>
        <div>Permission : {stats.TotalPermission}</div>
      </>
    )}

    {/* ✅ ALWAYS SHOW */}
    <div>Data Found : {rowsCount}</div>
  </div>
</div>



    </>
  );
}

export default SmartSearchNavbar;
